import { modelRegistry } from 'customer-flows/quote/models'
import { type ResolverKey } from 'customer-flows/utils/quote/resolvers'

export function defineModel<T extends ModelType>(model: NoExtraKeys<ResolverKey | 'refid', T>): T {
  return model
}

export function attr<V extends ValidationLevel = 'optional'>(
  validate?: V
): AttrNode<V> {
  return {
    kind: 'attribute',
    validate: validate ?? ('optional' as V)
  }
}

export function resolvesTo<T extends ResolverKey, V extends ValidationLevel = 'optional'>(
  resolverKey: T,
  validate?: V
): ResolvesToNode<T, V> {
  return {
    kind: 'resolvesTo',
    resolverKey,
    validate: validate ?? ('optional' as V)
  }
}

export type QuoteType = 'strict' | 'sparse'
export type BuilderData = { [_K in ResolverKey]?: any }

export type ValidationLevel = 'strict' | 'sparse' | 'optional'
export type DataType = 'string' | 'number' | 'boolean' | 'array' | 'object'

export interface AttrNode<TVal extends ValidationLevel = 'optional'> {
  kind: 'attribute'
  validate: TVal
}

export interface ResolvesToNode<TKey extends ResolverKey = ResolverKey, TVal extends ValidationLevel = 'optional'> {
  kind: 'resolvesTo'
  resolverKey: TKey
  validate: TVal
}

export type SchemaNode = AttrNode<any> | ResolvesToNode<any, any>
export type ModelType = Partial<Record<ResolverKey | 'refid', SchemaNode>>
export type QuoteModel<T extends ModelKey> = ModelRegistry[T]
export type ModelRegistry = typeof modelRegistry
export type ModelKey = keyof ModelRegistry
export type ModelKeyWithRefid<T extends ModelKey = ModelKey> = T | `${T}:${string}`
export type NoExtraKeys<Allowed extends PropertyKey, T extends object> = T & Record<Exclude<keyof T, Allowed>, never>
